import changeSelectedFilePickerViewBasedOnUserPreferredView from './changeSelectedFilePickerViewBasedOnUserPreferredView';
import changeSelectedFileProviderToDefault from './changeSelectedFileProviderToDefault';
import changeUserPreferredViewType from './changeUserPreferredViewType';
import refreshFileProviderItems from './refreshFileProviderItems';
import setCustomUploadConfiguration from '../actions/setCustomUploadConfiguration';
import datapoints from '../datapoints';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import FilePickerUploadConfiguration from '../store/schema/FilePickerUploadConfiguration';
import { FilePickerViewType } from '../types/FilePickerViewSwitcher';
import { FileSelectionFilter } from 'owa-fileprovider-store';
import { getFileProviders } from 'owa-fileprovider-store/lib/selectors/getFileProviders';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export default createLegacyActionWithDatapoint('showFilePicker', datapoints.FPShowFilePicker)(
    function showFilePicker(
        filter: FileSelectionFilter,
        viewType: FilePickerViewType | null,
        viewState: FilePickerPanelViewState,
        uploadConfig: FilePickerUploadConfiguration | null
    ) {
        const previousFileSelectionFilter = viewState.fileSelectionFilter;

        if (getFileProviders().length === 0) {
            // If there are no file providers in the viewState then
            // call the action to get all the file providers that user has
            // TODO: See what needs to be done if the user has no file provider. Here we will always make a service call in that case
            if (!viewState.selectedFileProvider && getFileProviders().length !== 0) {
                changeSelectedFileProviderToDefault(filter, previousFileSelectionFilter, viewState);

                if (viewType !== null) {
                    changeSelectedFilePickerViewBasedOnUserPreferredView(
                        viewState.selectedFileProvider,
                        viewState.filePickerViewState
                    );
                }
            }
        } else {
            // We need to update the file provider to show based on the
            // selection filter and select the default provider
            changeSelectedFileProviderToDefault(filter, previousFileSelectionFilter, viewState);
        }

        viewState.fileSelectionFilter = filter;
        if (viewType !== null) {
            // If a view type was provided then set is as the user preferred view
            changeUserPreferredViewType(viewType, viewState.filePickerViewState);

            if (viewState.selectedFileProvider) {
                changeSelectedFilePickerViewBasedOnUserPreferredView(
                    viewState.selectedFileProvider,
                    viewState.filePickerViewState
                );
            }
        }
        if (uploadConfig) {
            setCustomUploadConfiguration(uploadConfig);
        }

        viewState.isOpen = true;

        refreshFileProviderItems();
    }
);
